import SmoAuth from '../api/aws/smo-auth'
import { getObj as isEmailPreRegistered } from '../api/pre-register'
import { putObj as putUser, getByEmail as getUserByEmail } from '../api/users'
import { showSuccess } from './alerts'

export const SIGN_UP = 'SIGN_UP'
export const SIGN_UP_FAIL = 'SIGN_UP_FAIL'
export const SIGN_UP_FAIL_NOT_WHITELISTED = 'SIGN_UP_FAIL_NOT_WHITELISTED'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCEES'

export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_FAIL = 'SIGN_IN_FAIL'
export const SIGN_IN_FAIL_NOT_VERIFIED = 'SIGN_IN_FAIL_NOT_VERIFIED'
export const SIGN_IN_FAIL_NOT_REGISTERED = 'SIGN_IN_FAIL_NOT_REGISTERED'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'

export const SIGN_OUT = 'SIGN_OUT'
export const SIGN_OUT_FAIL = 'SIGN_OUT_FAIL'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'

export const VERIFY = 'VERIFY'
export const VERIFY_FAIL = 'VERIFY_FAIL'
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS'

export const RESEND = 'RESEND'
export const RESEND_FAIL = 'RESEND_FAIL'
export const RESEND_SUCCESS = 'RESEND_SUCCESS'

export const NAVIGATE_LOGIN = 'NAVIGATE_LOGIN'
export const NAVIGATE_REGISTER = 'NAVIGATE_REGISTER'
export const NAVIGATE_RESET_PASSWORD = 'NAVIGATE_RESET_PASSWORD'

export const TOKEN_RECEIVED = 'TOKEN_RECEIVED'
export const TOKEN_ERROR = 'TOKEN_ERROR'

export const RESET_REQUEST = 'RESET_REQUEST'
export const RESET_REQUEST_SUCCESS = 'RESET_REQUEST_SUCCESS'
export const RESET_REQUEST_FAIL = 'RESET_REQUEST_FAIL'

export const RESET_SUBMIT = 'RESET_SUBMIT'
export const RESET_SUBMIT_SUCCESS = 'RESET_SUBMIT_SUCCESS'
export const RESET_SUBMIT_FAIL = 'RESET_SUBMIT_FAIL'

const smoAuth = new SmoAuth()

export const signUp = (authUser) => (dispatch) => {
    dispatch({ type: SIGN_UP })

    // Check if whitelisted email
    isEmailPreRegistered(authUser.email.toLowerCase())
        .then((prRes) => {
            if (prRes.exists === false) {
                dispatch({ type: SIGN_UP_FAIL_NOT_WHITELISTED })
            } else {
                // Sign up to cognito
                smoAuth
                    .signUp(
                        authUser.email.toLowerCase(),
                        authUser.password,
                        authUser.email.toLowerCase()
                    )
                    .then((res) => {
                        dispatch({ type: SIGN_UP_SUCCESS })
                    })
                    .catch((err) => {
                        dispatch({
                            type: SIGN_UP_FAIL,
                            payload: { errorMessage: err.message },
                        })
                    })
            }
        })
        .catch((err) => {
            dispatch({
                type: SIGN_UP_FAIL,
                payload: { errorMessage: err.message },
            })
        })
}

export const signIn = (authUser) => (dispatch) => {
    dispatch({ type: SIGN_IN })

    // Cognito sign in
    smoAuth
        .signInAndGetToken(authUser.email.toLowerCase(), authUser.password)
        .then((token) => {
            // Get user from DB
            getUserByEmail(authUser.email.toLowerCase(), token)
                .then((user) => {
                    dispatch({
                        type: SIGN_IN_SUCCESS,
                        payload: { user: user, token: token },
                    })
                })
                .catch((err) => {
                    dispatch({
                        type: SIGN_IN_FAIL,
                        payload: { errorMessage: err.message },
                    })
                })
        })
        .catch((err) => {
            switch (err.code) {
                case 'UserNotFoundException':
                    dispatch({ type: SIGN_IN_FAIL_NOT_REGISTERED })
                    break
                case 'UserNotConfirmedException':
                    dispatch({ type: SIGN_IN_FAIL_NOT_VERIFIED })
                    break
                default:
                    dispatch({
                        type: SIGN_IN_FAIL,
                        payload: { errorMessage: err.message },
                    })
            }
        })
}

export const signOut = () => (dispatch) => {
    dispatch({ type: SIGN_OUT })
    smoAuth
        .signout()
        .then((res) => {
            dispatch({ type: SIGN_OUT_SUCCESS })
        })
        .catch((err) => {
            dispatch({
                type: SIGN_OUT_FAIL,
            })
        })
}

export const verifyCode = (authUser, code) => (dispatch) => {
    dispatch({ type: VERIFY })

    smoAuth
        .verifyAndSignInAndGetToken(
            authUser.email.toLowerCase(),
            authUser.password,
            code
        )
        .then((token) => {
            // Save user in docDB
            putUser(
                {
                    email: authUser.email.toLowerCase(),
                    firstName: authUser.firstName,
                    lastName: authUser.lastName,
                    department: authUser.department,
                },
                token
            )
                .then(() => {
                    dispatch({ type: VERIFY_SUCCESS })
                    dispatch(
                        showSuccess('Registration successful. Please login!')
                    )
                })
                .catch((err) => {
                    dispatch({
                        type: SIGN_UP_FAIL,
                        payload: { errorMessage: err.message },
                    })
                })
        })
        .catch((err) => {
            dispatch({
                type: VERIFY_FAIL,
                payload: {
                    errorMessage: err.message,
                },
            })
        })
}

export const resendCode = (email) => (dispatch) => {
    dispatch({ type: RESEND })
    smoAuth
        .resendCode(email.toLowerCase())
        .then((res) => {
            dispatch({ type: RESEND_SUCCESS })
        })
        .catch((err) => {
            dispatch({
                type: RESEND_FAIL,
                payload: {
                    errorMessage: err.message,
                },
            })
        })
}

export const resetPasswordRequest = (email) => (dispatch) => {
    dispatch({ type: RESET_REQUEST })

    smoAuth
        .resetPasswordRequest(email)
        .then((res) => {
            dispatch({ type: RESET_REQUEST_SUCCESS })
        })
        .catch((err) => {
            dispatch({
                type: RESET_REQUEST_FAIL,
                payload: {
                    errorMessage: err.message,
                },
            })
        })
}

export const resetPasswordSubmit = (email, verficationCode, newPassword) => (dispatch) => {
    dispatch({ type: RESET_SUBMIT })
    smoAuth
        .resetPassword(email, verficationCode, newPassword)
        .then(() => {
            dispatch({ type: RESET_SUBMIT_SUCCESS })
        })
        .catch((err) => {
            dispatch({
                type: RESET_SUBMIT_FAIL,
                payload: {
                    errorMessage: err.message,
                },
            })
        })
}

export const navigateRegister = () => (dispatch) => {
    dispatch({ type: NAVIGATE_REGISTER })
}

export const navigateLogin = () => (dispatch) => {
    dispatch({ type: NAVIGATE_LOGIN })
}

export const navigateResetPassword = () => (dispatch) => {
    dispatch({ type: NAVIGATE_RESET_PASSWORD })
}
